import i18n from 'i18next';

export const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = i18n.t('validation_error_name_required');
  }

  if (!values.phone || values.phone.includes('_')) {
    errors.phone = i18n.t('validation_error_phone_required');
  }

  if (!values.agreeToTermsAndPrivacy) {
    errors.agreeToTermsAndPrivacy = i18n.t('validation_error_agreement_required');
  }

  return errors;
};